import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getColKey as L, createCustomWidthStyle as E } from "./utils.js";
import { formatLength as k } from "../../_utils/css/format-length.js";
import { computed as n } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function g(d, f) {
  const i = [], x = [], R = [], p = /* @__PURE__ */ new WeakMap();
  let h = -1, w = 0, c = !1, s = 0;
  function y(C, a) {
    a > h && (i[a] = [], h = a), C.forEach((e) => {
      if ("children" in e)
        y(e.children, a + 1);
      else {
        const t = "key" in e ? e.key : void 0;
        x.push({
          key: L(e),
          style: E(e, t !== void 0 ? k(f(t)) : void 0),
          column: e,
          index: s++,
          // The width property is only applied to horizontally virtual scroll table
          width: e.width === void 0 ? 128 : Number(e.width)
        }), w += 1, c || (c = !!e.ellipsis), R.push(e);
      }
    });
  }
  y(d, 0), s = 0;
  function I(C, a) {
    let e = 0;
    C.forEach((t) => {
      var S;
      if ("children" in t) {
        const o = s, l = {
          column: t,
          colIndex: s,
          colSpan: 0,
          rowSpan: 1,
          isLast: !1
        };
        I(t.children, a + 1), t.children.forEach((r) => {
          var v, u;
          l.colSpan += (u = (v = p.get(r)) === null || v === void 0 ? void 0 : v.colSpan) !== null && u !== void 0 ? u : 0;
        }), o + l.colSpan === w && (l.isLast = !0), p.set(t, l), i[a].push(l);
      } else {
        if (s < e) {
          s += 1;
          return;
        }
        let o = 1;
        "titleColSpan" in t && (o = (S = t.titleColSpan) !== null && S !== void 0 ? S : 1), o > 1 && (e = s + o);
        const l = s + o === w, r = {
          column: t,
          colSpan: o,
          colIndex: s,
          rowSpan: h - a + 1,
          isLast: l
        };
        p.set(t, r), i[a].push(r), s += 1;
      }
    });
  }
  return I(d, 0), {
    hasEllipsis: c,
    rows: i,
    cols: x,
    dataRelatedCols: R
  };
}
function W(d, f) {
  const i = n(() => g(d.columns, f));
  return {
    rowsRef: n(() => i.value.rows),
    colsRef: n(() => i.value.cols),
    hasEllipsisRef: n(() => i.value.hasEllipsis),
    dataRelatedColsRef: n(() => i.value.dataRelatedCols)
  };
}
export {
  W as useGroupHeader
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/use-group-header.js
// module id = 1617
// module chunks = 41